import DOMPurify from 'dompurify';

export const sanitizeUrl = (url: string): string => {
  return DOMPurify.sanitize(url);
};
